export * from './mask-modal/mask-modal.component';
export { RechargeModalComponent } from './recharge-modal/recharge-modal.component';
export { DeductionModalComponent } from './deduction-modal/deduction-modal.component';

export const components: any[] = 
[
    MaskModalComponent,
    RechargeModalComponent,
    DeductionModalComponent
]

import { DeductionModalComponent } from './deduction-modal/deduction-modal.component';
import { MaskModalComponent } from './mask-modal/mask-modal.component';
import { RechargeModalComponent } from './recharge-modal/recharge-modal.component';
